import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
export class KeyringHookMobileEditor {
  constructor({ window, document }) {
    this._window = window;
    this._document = document;
    this._svg_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "svg"
    );
    this._container_el = null;
    this._canvas_el = null;
    this._dummy_g_el = null;
    this._layers_el = null;
    this._art_board_layer_el = null;
    this._target_image_layer_el = null;
    this._hook_layer_el = null;
    this._art_board_rect_el = null;
    this._art_board_filter_el = null;
    this._art_board_filter_drop_shadow_el = null;
    this._art_board_shape_path_el = null;
    this._target_image_dummy_g_el = null;
    this._hook_g_el = null;
    this._hook_empty_path_el = null;
    this._hook_path_el = null;
    this._view_port = null;
    this._view_box = null;
    this._art_board = null;
    this._stroke_sync = null;
    this._target_image_el = null;
  }
  initDOM() {
    return BaseNS.initDOM(this);
  }
  initEditor() {
    return BaseNS.initEditor(this);
  }
  destroy() {
    return BaseNS.destroy(this);
  }
  appendTo(container_el) {
    return BaseNS.appendTo(this, container_el);
  }
  fitSize() {
    return BaseNS.fitSize(this);
  }
  setArtBoardSize(payload) {
    return BaseNS.setArtBoardSize(this, payload);
  }
  setArtBoardShapePath(payload) {
    return BaseNS.setArtBoardShapePath(this, payload);
  }
  calculateViewBoxFitToArtBoard(config) {
    return BaseNS.calculateViewBoxFitToArtBoard(this, config);
  }
  setViewBox(view_box_vo) {
    return BaseNS.setViewBox(this, view_box_vo);
  }
  setTargetImageEl(target_image_el) {
    return BaseNS.setTargetImageEl(this, target_image_el);
  }
  setHookSize(payload) {
    return BaseNS.setHookSize(this, payload);
  }
  setHookPosition(payload) {
    return BaseNS.setHookPosition(this, payload);
  }
  getIsInHookEl(node) {
    return BaseNS.getIsInHookEl(this, node);
  }
  convertCoordsToInside(payload) {
    return BaseNS.convertCoordsToInside(this, payload);
  }
  convertCoordsToOutside(payload) {
    return BaseNS.convertCoordsToOutside(this, payload);
  }
  _getContainerElThrowable() {
    return BaseNS._getContainerElThrowable(this);
  }
  _getCanvasElThrowable() {
    return BaseNS._getCanvasElThrowable(this);
  }
  _getDummyGElThrowable() {
    return BaseNS._getDummyGElThrowable(this);
  }
  _getLayersElThrowable() {
    return BaseNS._getLayersElThrowable(this);
  }
  _getArtBoardLayerElThrowable() {
    return BaseNS._getArtBoardLayerElThrowable(this);
  }
  _getTargetImageLayerElThrowable() {
    return BaseNS._getTargetImageLayerElThrowable(this);
  }
  _getHookLayerElThrowable() {
    return BaseNS._getHookLayerElThrowable(this);
  }
  _getArtBoardRectElThrowable() {
    return BaseNS._getArtBoardRectElThrowable(this);
  }
  _getArtBoardFilterElThrowable() {
    return BaseNS._getArtBoardFilterElThrowable(this);
  }
  _getArtBoardFilterDropShadowElThrowable() {
    return BaseNS._getArtBoardFilterDropShadowElThrowable(this);
  }
  _getArtBoardShapePathElThrowable() {
    return BaseNS._getArtBoardShapePathElThrowable(this);
  }
  _getTargetImageDummyGElThrowable() {
    return BaseNS._getTargetImageDummyGElThrowable(this);
  }
  _getHookGElThrowable() {
    return BaseNS._getHookGElThrowable(this);
  }
  _getHookEmptyPathElThrowable() {
    return BaseNS._getHookEmptyPathElThrowable(this);
  }
  _getHookPathElThrowable() {
    return BaseNS._getHookPathElThrowable(this);
  }
  _getViewPortThrowable() {
    return BaseNS._getViewPortThrowable(this);
  }
  _getViewBoxThrowable() {
    return BaseNS._getViewBoxThrowable(this);
  }
  _getArtBoardThrowable() {
    return BaseNS._getArtBoardThrowable(this);
  }
  _getStrokeSyncThrowable() {
    return BaseNS._getStrokeSyncThrowable(this);
  }
}
